// Lote V-11.C — Web client para as facturas do usuario.

import { apiClient } from './client';
import type { InvoiceListItem } from '@leyrochain/shared';

export type { InvoiceListItem };

export interface InvoicesListResponse {
  items: InvoiceListItem[];
  total: number;
  page: number;
  page_size: number;
}

export async function listMyInvoices(page = 1, pageSize = 50): Promise<InvoicesListResponse> {
  const { data } = await apiClient.get<InvoicesListResponse>(
    `/api/v1/users/me/invoices?page=${page}&page_size=${pageSize}`,
  );
  return data;
}

export async function getInvoiceDownloadUrl(id: string): Promise<string> {
  const { data } = await apiClient.get<{ url: string; expires_in_seconds: number }>(
    `/api/v1/users/me/invoices/${encodeURIComponent(id)}/download`,
  );
  return data.url;
}

export async function markInvoiceRead(id: string): Promise<void> {
  await apiClient.patch(`/api/v1/users/me/invoices/${encodeURIComponent(id)}/read`);
}
